module.exports = __webpack_public_path__ + "streamline-24px-filled-in.145dd328456c5eeeb06c.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/assets/fonts/streamline/streamline-24px-filled-in.woff
// module id = ../../../../../src/assets/fonts/streamline/streamline-24px-filled-in.woff
// module chunks = styles